/**
 * Lite Firestore instance — used by the PUBLIC pages only.
 *
 * `firebase/firestore/lite` is a REST-based, listener-free build of the
 * Firestore SDK. It is roughly 70 kB (gzip) smaller than the full SDK
 * because it drops the WebChannel transport, the offline persistence
 * layer and the real-time watch machinery.
 *
 * The public site is a brochure: prices/gallery/team change rarely, so a
 * one-shot read per page load is the right trade. The admin panel keeps
 * the full SDK (with real-time listeners) in its own lazy-loaded chunk —
 * see firebase/config.js.
 *
 * Both SDKs can safely share one FirebaseApp; they register as separate
 * components and hand back independent Firestore instances.
 */
import { getFirestore } from 'firebase/firestore/lite';
import { app } from './app';

export const liteDb = getFirestore(app);
